// When the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const customColorField = document.getElementById('custom-color-option');
  if (customColorField) {
    customColorField.style.display = 'none';
  }
});

// Listen for variant changes
document.addEventListener('on:variant:change', (event) => {
  const customColorField = document.getElementById('custom-color-option');
  const selectedVariant = event.detail.variant;
  
  // Hide the field initially
  customColorField.style.display = 'none';
  
  // Check if we have a variant and if its option includes "custom stitch color"
  if (selectedVariant && selectedVariant.options.some(option => 
    option.toLowerCase() === 'custom stitch color'
  )) {
    customColorField.style.display = 'block';
  }
});